// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zyR3","newExpiryDate":"styles_newExpiryDate__3XKQ5","footer":"styles_footer__1iKWi"};